
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ar/contact",
      function () {
        return require("private-next-pages/ar/contact.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ar/contact"])
      });
    }
  